import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { OrderItemFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface NameFormInputProps {}

export const NameFormInput = ({}: NameFormInputProps) => {
  const { control, watch } = useFormContext<OrderItemFormValues>();
  const { t } = useTranslation("stockorder");

  const watchedProductId = watch("productId");

  const watchedId = watch("id");
  const disabled = watchedProductId || watchedId;

  return (
    <View pointerEvents={disabled ? "none" : "auto"}>
      <Label label={t("form.name.label")}></Label>
      <Controller
        name="name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.name.placeholder")}
            editable={!disabled}
            selectTextOnFocus={!disabled}
            style={{
              opacity: disabled ? 0.7 : 1,
            }}
          />
        )}
      />
    </View>
  );
};
